
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Home } from './Home';
import  About  from './About';
import  Contact  from './Contact';
import { Layout } from './components/Layout';
import { NavigationBar } from './components/NavigationBar';
import Navigationdowen  from './components/Navigationdowen';
import Screen from './components/Screen'; 
import HamburgerMenu from './components/Nav/HamburgerMenu';
import Slider from './components/Slider/Slider';
import styled from "styled-components";
import CookieConsent from './CookieConsent';
import Background from "./assets/macbook-624707.jpg";
import AccessibilityWidget from "./AccessibilityWidget";
import WhatsAppBot from "./WhatsAppBot";

import './App.css';

const Styleapp = styled.div`
  background-color: #081a2f;
  min-height: 100vh;
  width: 100%;
`;




class App extends Component {

seo = {
  title: "בניית אתרים לעסקים שמביאים לקוחות",
  description:
    "בניית אתרי אינטרנט מקצועיים עם דגש על קידום בגוגל, מהירות גבוהה ועיצוב שממיר לקוחות בפועל.",
  keywords:
    "בניית אתרים לעסקים, קידום אתרים, אתר שמביא לקוחות, עיצוב אתרים מקצועי",
  url: "https://siteb2b.co.il/",
  image: "/logo1922.png"
};


render() {

return (


<Styleapp className="App">


<Router>


<Helmet>

<title>{this.seo.title}</title>

<meta 
name="description" 
content={this.seo.description}
/>

<meta 
name="keywords" 
content={this.seo.keywords}
/>


<meta property="og:title" content={this.seo.title}/>

<meta property="og:description" content={this.seo.description}/>

<meta property="og:image" content={this.seo.image}/>

<meta property="og:url" content={this.seo.url}/>

<meta property="og:type" content="website"/>

</Helmet>



<WhatsAppBot />

<AccessibilityWidget />



<div id="site-content">


<NavigationBar />

<HamburgerMenu />

<Screen />


<CookieConsent />



<Switch>

<Route exact path="/" component={Home}/>

<Route path="/Mysite" component={Slider}/>

<Route path="/About" component={About}/>

<Route path="/Contact" component={Contact}/>

</Switch>



<Navigationdowen />


</div>



</Router>


</Styleapp>

);

}

}
export default App;





///display: block;
///width: auto;
///height: auto;
///background:url(${Background}); 
///background-repeat: no-repeat;
///background-attachment: fixed;
///background-position: center;
///background-size: cover;
///z-index : -100000;

///@media only Screen and (max-width: 40em) {
 /// width: auto;
 // height: auto;
 /// background-position: top center;
 /// background-repeat:no-repeat;
 /// background-size: cover;
 /// z-index: -1;
 // opacity: 1.0;
 /// .slick-slider .slick-arrow {
 ///   display: none;
  //  width: auto;
 /// }
